import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	container: {
		padding: theme.spacing(2, 2, 2, 0)
	},
	disconnectedContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.red[400]),
		"& svg": {
			color: colors.red[400]
		}
	},
	reconnectingContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[300]),
		"& svg": {
			color: colors.yellow[300]
		}
	},
	messageContainer: {
		flex: 1
	},
	iconContainer: {
		width: 80
	},
	linkText: {
		cursor: "pointer"
	},
	icon: {
		width: 40,
		height: 40,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[300]),
		borderRadius: 20
	},
	statusDescriptionText: {
		color: colors.gray[700],
		fontSize: 14,
		lineHeight: "20px"
	}
}))

export default useStyles
